import React from "react";

const Character_Types = () => {
  return (
    <div>
      <h1>Character_Types Component</h1>
      <p>Content for Character_Types goes here...</p>
    </div>
  );
};

export default Character_Types;
